import React, { useState } from "react";
import axios from "axios";
import Dropzone from "react-dropzone";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { SingleImageDropzone } from "../DropzoneComponents";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

const BrandCreate = () => {
  const navigate = useNavigate();
  const [settings, setSettings] = useState(null);
  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, def) => translations[key] || def;

  const [form, setForm] = useState({
    title: "",
    status: "aktif",
  });

  const [file, setFile] = useState(null);
  React.useEffect(() => {
    const token = localStorage.getItem("admin_token");
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setSettings(res.data))
      .catch(() => toast.error(getText("SETTINGS_FETCH_ERROR")));

  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();

    data.append("title", form.title);
    data.append("status", form.status);
    if (file) data.append("image", file);

    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/stock-brands/create`,
        data,
      );
      toast.success(getText("BRAND_CREATED_SUCCESS"));

      navigate("/brands/table");
    } catch {
     toast.error(getText("BRAND_CREATED_ERROR"));

    }
  };

  return (
    <div className="container mt-4">
      <form className="card p-4" onSubmit={handleSubmit}>

        <label className="form-label">{getText("BRAND_NAME_LABEL")}</label>
        <input
          className="form-control mb-3"
          value={form.title}
          onChange={(e) => setForm({ ...form, title: e.target.value })}
          required
        />

        <label className="form-label fw-bold">
           {getText("BRAND_LOGO_LABEL")}  ({settings?.brand_image_width}x
          {settings?.brand_image_height})
        </label>

        {settings ? (
          <SingleImageDropzone
            fieldName="image"
            fieldValue={file}
            setFieldValues={(fn) => {
              const val =
                typeof fn === "function" ? fn({ image: file }).image : fn.image;

              setFile(val || null);
            }}
            required={false}
            maxWidth={Number(settings.brand_image_width)}
            maxHeight={Number(settings.brand_image_height)}
          />
        ) : (
          <p>{getText("LOADING_SETTINGS")}</p>
        )}

        <label className="form-label">{getText("STATUS_LABEL")}</label>
        <select
          className="form-select mb-3"
          value={form.status}
          onChange={(e) => setForm({ ...form, status: e.target.value })}
        >
          <option value="aktif">{getText("STATUS_ACTIVE")}</option>
          <option value="pasif">{getText("STATUS_PASSIVE")}</option>
        </select>

        <div className="d-flex justify-content-center">
          <button className="btn btn-primary">{getText("SAVE")}</button>
        </div>
      </form>
    </div>
  );
};

export default BrandCreate;
